import BaseApi from '@/api/base-api'

class MerchantUserApi extends BaseApi {
  getMerchantUserProfile = () => {
    return this.request(
      {
        method: 'GET',
        path: this.uri + '/me',
      },
      {
        options: {
          hideMessage: true,
          reject403: true,
        },
      }
    )
  }

  addMerchantUserPhoneNumber = ({
    countryCallingCode,
    phoneNumber,
    channel,
  }) => {
    return this.request(
      {
        method: 'POST',
        path: this.uri + '/check-phone-number-exist',
        data: {
          country_code: countryCallingCode,
          phone_number: phoneNumber,
          channel: channel,
        },
      },
      {
        options: {
          hideMessage: true,
        },
      }
    )
  }

  verifyCollectPhoneByOtp = ({ otp, countryCallingCode, phoneNumber }) => {
    return this.request(
      {
        method: 'POST',
        path: this.uri + '/verify-collect-phone-otp',
        data: {
          country_code: countryCallingCode,
          phone_number: phoneNumber,
          otp: otp,
        },
      },
      {
        options: {
          hideMessage: true,
        },
      }
    )
  }

  resendOtpCollectPhone = ({ channel, countryCallingCode, phoneNumber }) => {
    return this.request(
      {
        method: 'POST',
        path: this.uri + '/resend-collect-phone-otp',
        data: {
          country_code: countryCallingCode,
          phone_number: phoneNumber,
          channel: channel,
        },
      },
      {
        options: {
          hideMessage: true,
        },
      }
    )
  }
}

export default new MerchantUserApi('/merchants/users')
